import type { PImage } from '../../engine/aliases'
import type { IDeadish, IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { assert } from '../../lib/assert-sidecar'
import { l } from '../../lib/imports'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import type { IVoyageBody } from './voyageBodies'
import { voyageBodies } from './voyageBodies-sidecar'
import type { IVoyageCarryable } from './voyageCarryable'
import type { IVoyageCrew } from './voyageCrew'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IVoyageJettison extends IEntity, IDeadish {
  image: PImage
  body: IVoyageBody | null
  deathTimer: number
  x: number
  y: number
  dx: number
  dy: number
}

const objs: IVoyageJettison[] = []
export function getAll() {
  return objs
}

export function create(
  crew: IVoyageCrew | null,
  carryable: IVoyageCarryable | null,
  x: number,
  y: number,
  dx: number,
  dy: number,
): IVoyageJettison {
  assert.notNil(crew || carryable, 'need either a crew or carryable')

  let frame = sprites.voyTileCrew[0]
  let scale = 2
  let body: IVoyageBody | null = null

  if (carryable) {
    if (carryable.image.fi) {
      frame = carryable.image.fi
      scale = carryable.image.scale
    }
    if (carryable.body) {
      body = carryable.body
      carryable.body = null
    }
  }
  if (crew && crew.crewState) {
    body = crew.crewState.body
  }
  let image = spritesUtil.createImage(
    voyageLayers.getLayers().shipCrewItem,
    frame,
  )
  image.scale = scale
  if (carryable) {
    //console.log('set tint', image.tint, carryable.image.tint)
    image.tint = carryable.data.tint
  }
  if (body) {
    image.visible = false
  }
  // console.log('tint', image.tint)
  // spritesUtil.scale(image, scale)

  let obj: IVoyageJettison = {
    id: createId(),
    idLoaded: -1,
    isDead: false,
    eType: 'voy-misc',
    image,
    body,
    deathTimer: 0,
    x,
    y,
    dx,
    dy,
  }

  objs.push(obj)

  return obj
}

export function moveToXY(
  obj: IVoyageJettison,
  x: number,
  y: number,
  // isFlipped = false,
) {
  obj.x = x
  obj.y = y
  obj.image.x = x
  obj.image.y = y
  if (obj.body) {
    voyageBodies.moveToXY(obj.body, x, y, false)
  }
}

export function kill(obj: IVoyageJettison) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
    if (c.body) {
      voyageBodies.kill(c.body)
    }
  })
}
function update(obj: IVoyageJettison) {
  let ds = common.getUpdateDelta()

  if (obj.isDead) {
    return
  }

  let speed = 200
  obj.x += obj.dx * speed * ds
  obj.y += obj.dy * speed * ds
  moveToXY(obj, obj.x, obj.y)

  obj.deathTimer += ds

  const deathTime = 2
  if (obj.deathTimer >= deathTime) {
    kill(obj)
  }
}
